'use client';

import type { GlobeMode } from '@morfi/globe';
import type { StoreApi, UseBoundStore } from 'zustand';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface GlobeState {
  open: boolean;
  mode: GlobeMode;
  /** Open the globe overlay, optionally on a specific mode. */
  openGlobe: (mode?: GlobeMode) => void;
  closeGlobe: () => void;
  setMode: (mode: GlobeMode) => void;
}

export const useGlobeStore: UseBoundStore<StoreApi<GlobeState>> = createTrackedStore<GlobeState>(
  'useGlobeStore',
)((set) => ({
  open: false,
  mode: 'market',
  openGlobe: (mode?: GlobeMode): void => {
    set(mode ? { open: true, mode } : { open: true });
  },
  closeGlobe: (): void => {
    set({ open: false });
  },
  setMode: (mode: GlobeMode): void => {
    set({ mode });
  },
}));
